import { forwardRef } from "react"
import { SnsFb, SnsTw } from './sns'
import { BtnPageTop } from './btn-page-top'

export const CorpFooter = forwardRef<HTMLElement>((_props, ref) => {
  return <footer className="ftr" ref={ref}>
    <div className="ftr__logo">
      <a href="index.html" target="_self">Family Works</a>
    </div>
    <ul className="ftr__nav">
      <li><a href="./company.html" target="_self">会社概要</a></li>
      <li className="hide-nofaq"><a href="./faq.html" target="_self">よくある質問</a></li>
      <li className="hide-nocontact"><a href="./contact.html" target="_self">お問い合わせ</a></li>
      <li><a href="./termsofuse.html" target="_self">利用規約</a></li>
      <li><a href="./privacypolicy.html" target="_self">プライバシーポリシー</a></li>
      <li><a href="./informationProvision.html" target="_self">提携先企業との情報提供</a></li>
      <li><a href="./salespolicy.html" target="_self">特定商取引法に基づく表記</a></li>
      <li><a href="./premiumContract.html" target="_self">プレミアムプラン利用規約</a></li>
      <li><a href="./externaltransmission.html" target="_self">お客さま情報の外部送信について</a></li>
      <li><a href="./manual.html" target="_self">操作マニュアル</a></li>
      <li><a href="../dendaigyo.html" target="_self">電子決済等代行業に係る銀行法に基づく表示について</a></li>
    </ul>
    <div className="ftr__sns" />
    <div className="ftr__copy">
      <small>&copy; SMBC FAMILY WORKS</small>
    </div>
    <BtnPageTop />
  </footer>

})